export default "__VITE_ASSET__BYLR_fuL__"